"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveValue = void 0;
// copied over from @forge/ui
// helper function that resolves a value from a promise or returns the original value
const resolveValue = async (defaultValue) => {
    const value = defaultValue instanceof Function ? defaultValue() : defaultValue;
    return await value;
};
exports.resolveValue = resolveValue;
